<div class="hidden lg:block">
  <div class="px-4 mb-4">
    <app-plant-filters (filterChange)="onFilterSelectionChange($event)">
      <button
        pButton
        label="Créer une règle (avec brouillons)"
        icon="pi pi-plus"
        class="p-button-sm"
        (click)="openCreateDialog()"
        *ind4HasRole="'SED_PLUS_SUPER_USER'"
      ></button>
      <button
        pButton
        label="Créer une règle (simple)"
        icon="pi pi-plus"
        class="p-button-sm p-button-outlined"
        (click)="openSimpleCreateDialog()"
        *ind4HasRole="'SED_PLUS_SUPER_USER'"
      ></button>
    </app-plant-filters>
  </div>

  <div class="px-4">
    <div *ngIf="!hasWorkCenterSelected" class="card p-6 text-center">
      <i class="pi pi-filter text-4xl text-gray-400 mb-3"></i>
      <p class="text-gray-600 dark:text-gray-300">
        Veuillez sélectionner une usine, un groupe de gestion et un seul poste
        de travail pour accéder aux fonctionnalités.
      </p>
    </div>

    <div *ngIf="hasWorkCenterSelected">
      <div class="card p-4 mb-4" *ind4HasRole="'SED_PLUS_SUPER_USER'">
        <button
          pButton
          label="Gérer les étiquettes"
          icon="pi pi-tags"
          class="p-button-outlined"
          (click)="openLabelDialog()"
        ></button>
      </div>
    </div>

    <div *ngIf="hasWorkCenterSelected">
      <div class="relative">
        <p-table
          #criteriatable
          [value]="groupedRules"
          [lazy]="true"
          (onLazyLoad)="loadData($event)"
          [rows]="fullTableState.rows"
          [sortField]="fullTableState.sortField"
          [sortOrder]="fullTableState.sortOrder"
          [first]="fullTableState.first"
          [filters]="fullTableState.filters"
          [totalRecords]="totalRecords"
          [loading]="loading"
          [showLoader]="false"
          [paginator]="false"
          [tableStyle]="{ 'table-layout': 'fixed', width: '100%' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="w-[15%]">
                <div class="flex flex-wrap items-center justify-center w-full">
                  <div class="flex items-center justify-between w-full">
                    <span>Poste technique</span>
                    <p-sortIcon
                      pSortableColumn="equipmentReference"
                      field="equipmentReference"
                    />
                  </div>
                  <div class="mt-2 w-full">
                    <p-columnFilter
                      [showClearButton]="false"
                      type="text"
                      field="equipmentReference"
                      name="equipmentReference"
                      class="small-filter-input"
                      placeholder="Filtrer par modèle"
                      [style]="{ width: '100%' }"
                      size="small"
                    >
                    </p-columnFilter>
                  </div>
                </div>
              </th>

              <th class="w-[9%]">
                <div class="flex flex-wrap items-center justify-center w-full">
                  <div class="flex items-center justify-between w-full">
                    <span>ID sap</span>
                    <p-sortIcon pSortableColumn="SAPId" field="SAPId" />
                  </div>
                  <div class="mt-2 w-full">
                    <p-columnFilter
                      [showClearButton]="false"
                      type="text"
                      field="SAPId"
                      name="SAPId"
                      class="small-filter-input"
                      placeholder="Filtrer par id SAP"
                      [style]="{ width: '100%' }"
                      size="small"
                    >
                    </p-columnFilter>
                  </div>
                </div>
              </th>

              <th class="w-[15%]">
                <div class="flex flex-wrap items-center justify-center w-full">
                  <div class="flex items-center justify-between w-full">
                    <span>Contexte</span>
                    <p-sortIcon pSortableColumn="context" field="context" />
                  </div>
                  <div class="mt-2 w-full">
                    <p-columnFilter
                      [showClearButton]="false"
                      type="text"
                      field="context"
                      name="context"
                      class="small-filter-input"
                      placeholder="Filtrer par contexte"
                      [style]="{ width: '100%' }"
                      size="small"
                    >
                    </p-columnFilter>
                  </div>
                </div>
              </th>

              <th style="width: 12%">
                <div class="flex flex-wrap items-center justify-center w-full">
                  <div class="flex items-center justify-between w-full">
                    <span>Date / Heure de début</span>
                    <p-sortIcon
                      pSortableColumn="latestAlarmStartDate"
                      field="latestAlarmStartDate"
                    />
                  </div>
                  <div class="mt-2 w-full">
                    <p-columnFilter
                      class="ml-auto column-filter-full-width"
                      field="latestAlarmStartDate"
                      [showMenu]="false"
                      [showClearButton]="false"
                      dataType="date"
                      matchMode="equals"
                    >
                      <ng-template
                        pTemplate="filter"
                        let-value
                        let-applyFilter="filterCallback"
                      >
                        <p-datepicker
                          placeholder="Filtrer par date de l'alarme"
                          [style]="{
                            width: '100%',
                            padding: '0',
                          }"
                          [(ngModel)]="pickedDate"
                          name="pickedDate"
                          size="small"
                          showIcon
                          iconDisplay="input"
                          hourFormat="24"
                          class="text-sm"
                          [showTime]="true"
                          [hideOnDateTimeSelect]="false"
                          styleClass="text-sm p-inputtext-sm"
                        >
                          <ng-template pTemplate="footer">
                            <div class="w-full flex justify-end">
                              <button
                                pButton
                                type="button"
                                label="Save"
                                class="p-button-sm"
                                (click)="applyFilter(pickedDate)"
                              ></button>
                            </div>
                          </ng-template>
                        </p-datepicker>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </th>

              <th class="w-[6%]">
                <div class="flex flex-wrap items-center justify-center w-full">
                  <div class="flex items-center justify-between w-full">
                    <span>Maturité</span>
                    <p-sortIcon pSortableColumn="ruleStage" field="ruleStage" />
                  </div>
                  <div class="mt-2 w-full">
                    <p-columnFilter
                      class="ml-auto column-filter-full-width"
                      field="ruleStage"
                      [showMenu]="false"
                      [showClearButton]="false"
                    >
                      <ng-template
                        #filter
                        pTemplate="filter"
                        let-value
                        let-filter="filterCallback"
                      >
                        <p-select
                          [options]="stageOptions"
                          [style]="{ width: '100%' }"
                          [(ngModel)]="selectedStage"
                          name="selectedStage"
                          (onChange)="filter($event.value.toString())"
                          placeholder="Filtrer par maturité"
                          size="small"
                        ></p-select>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </th>

              <th class="w-[6%]">
                <div class="flex flex-wrap items-center justify-center w-full">
                  <div class="flex items-center justify-between w-full">
                    <span>Criticité</span>
                    <p-sortIcon
                      pSortableColumn="criticality"
                      field="criticality"
                    />
                  </div>
                  <div class="mt-2 w-full">
                    <p-columnFilter
                      class="ml-auto column-filter-full-width"
                      field="criticality"
                      [showMenu]="false"
                      [showClearButton]="false"
                    >
                      <ng-template
                        #filter
                        pTemplate="filter"
                        let-value
                        let-filter="filterCallback"
                      >
                        <p-select
                          [options]="criticalityOptions || []"
                          [style]="{ width: '100%' }"
                          [(ngModel)]="selectedCriticality"
                          name="selectedCriticality"
                          (onChange)="filter($event.value.toString())"
                          placeholder="Filtrer par criticité"
                          size="small"
                        ></p-select>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </th>

              <th class="w-[8%]">
                <div class="flex flex-wrap items-center justify-center w-full">
                  <div class="flex items-center justify-between w-full">
                    <span>D.S Alarme</span>
                    <div class="flex items-center gap-1">
                      <i
                        class="pi pi-info-circle text-xs"
                        pTooltip="Dépassement de seuil d'alarme"
                        tooltipPosition="top"
                      ></i>
                      <p-sortIcon
                        pSortableColumn="evaluationsAboveAlertThresholdRatio"
                        field="evaluationsAboveAlertThresholdRatio"
                      />
                    </div>
                  </div>
                  <div class="mt-2 w-full">
                    <p-columnFilter
                      [showClearButton]="false"
                      type="numeric"
                      field="evaluationsAboveAlertThresholdRatio"
                      name="evaluationsAboveAlertThresholdRatio"
                      class="small-filter-input"
                      placeholder="D. seuil"
                      [style]="{ width: '100%' }"
                      size="small"
                    >
                    </p-columnFilter>
                  </div>
                </div>
              </th>

              <th class="w-[7%]">
                <div class="flex flex-wrap items-center justify-center w-full">
                  <div class="flex items-center justify-between w-full">
                    <span>D.S Tolérance</span>
                    <div class="flex items-center gap-1">
                      <i
                        class="pi pi-info-circle text-xs"
                        pTooltip="Dépassement seuil de tolérance"
                        tooltipPosition="top"
                      ></i>
                      <p-sortIcon
                        pSortableColumn="evaluationsAboveToleranceThresholdRatio"
                        field="evaluationsAboveToleranceThresholdRatio"
                      />
                    </div>
                  </div>
                  <div class="mt-2 w-full">
                    <p-columnFilter
                      [showClearButton]="false"
                      type="numeric"
                      field="evaluationsAboveToleranceThresholdRatio"
                      name="evaluationsAboveToleranceThresholdRatio"
                      class="small-filter-input"
                      placeholder="D.S tolérance"
                      [style]="{ width: '100%' }"
                      size="small"
                    >
                    </p-columnFilter>
                  </div>
                </div>
              </th>

              <th class="w-[5%]">
                <div class="flex flex-wrap items-center justify-center w-full">
                  <div class="flex items-center justify-between w-full">
                    <span>Alarm</span>
                    <p-sortIcon pSortableColumn="alarm" field="alarm" />
                  </div>
                  <div class="mt-2 w-full">
                    <p-columnFilter
                      class="ml-auto column-filter-full-width"
                      field="alarm"
                      [showMenu]="false"
                      [showClearButton]="false"
                    >
                      <ng-template
                        #filter
                        pTemplate="filter"
                        let-value
                        let-filter="filterCallback"
                      >
                        <p-select
                          [options]="alarmStatusOptions || []"
                          [style]="{ width: '100%' }"
                          [(ngModel)]="selectedStatus"
                          name="selectedStatus"
                          (onChange)="filter($event.value.toString())"
                          placeholder="Filtrer par statut"
                          size="small"
                        ></p-select>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </th>

              <th style="width: 5%">
                <div class="flex flex-wrap items-center justify-center w-full">
                  <div class="flex items-center justify-between w-full">
                    <span>Santé</span>
                    <p-sortIcon pSortableColumn="ruleState" field="ruleState" />
                  </div>
                  <div class="mt-2 w-full">
                    <p-columnFilter
                      class="ml-auto column-filter-full-width"
                      field="ruleState"
                      [showMenu]="false"
                      [showClearButton]="false"
                    >
                      <ng-template
                        #filter
                        pTemplate="filter"
                        let-value
                        let-filter="filterCallback"
                      >
                        <p-select
                          [options]="ruleStateOptions || []"
                          [style]="{ width: '100%' }"
                          [(ngModel)]="selectedState"
                          name="selectedState"
                          (onChange)="filter($event.value.toString())"
                          placeholder="Filtrer par Santé"
                          size="small"
                        ></p-select>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-group let-rowIndex="rowIndex">
            <tr *ngIf="rowIndex === 0">
              <td colspan="10" class="p-0">
                <div class="mx-auto w-full grid grid-cols-2 gap-4 p-4">
                  <ng-container *ngFor="let g of groupedRules">
                    <div *ngIf="g.rules.length > 0">
                      <h3
                        class="text-lg font-semibold text-gray-800 dark:text-gray-100 px-4 py-2 bg-gray-50 dark:bg-gray-700 rounded-t-lg border-b border-gray-200 dark:border-gray-600"
                      >
                        <i class="pi pi-tag mr-2"></i>
                        {{ g.workCenterLabel?.label || "Sans étiquette" }}
                        <span
                          class="text-sm font-normal text-gray-500 dark:text-gray-400 ml-2"
                          >({{ g.rules.length }}
                          {{ g.rules.length === 1 ? "règle" : "règles" }})</span
                        >
                      </h3>
                      <div class="p-4">
                        <app-asset-group
                          [Rules]="g.rules"
                          [columns]="5"
                        ></app-asset-group>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="10" class="p-6">
                <span class="font-bold">Aucune donnée disponible.</span>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div
          *ngIf="loading"
          class="absolute inset-0 bg-gray-900/10 dark:bg-white/10 flex items-center justify-center z-0"
        >
          <p-progressSpinner ariaLabel="Loading"></p-progressSpinner>
        </div>
      </div>
    </div>
  </div>

  <app-label-management-dialog
    [(visible)]="labelDialogVisible"
    [labels]="labels"
    [loading]="loadingLabels"
    [workCenterId]="effectiveWorkCenterId"
    (labelsChanged)="onLabelsChanged()"
  ></app-label-management-dialog>
</div>
